import {
	CREATE_ORDER,
	INIT_ORDER,
	IS_LOADING,
	LOAD_ORDER,
	ORDER_FAILED,
	UPDATE_ORDER,
} from "./actionTypes";
const initialState = {
	order: {},
	isLoading: false,
	isSaving: false,
	isUpdated: false,
	isSaved: false,
	isFailed: false,
	isLoaded: false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case INIT_ORDER:
			return {
				order: {},
				isLoading: false,
				isSaving: false,
				isUpdated: false,
				isSaved: false,
				isFailed: false,
				isLoaded: false,
			};
		case IS_LOADING:
			return {
				...state,
				isLoading: true,
				isSaving: false,
				isUpdated: false,
				isSaved: false,
				isFailed: false,
				isLoaded: false,
			};

		case CREATE_ORDER:
			return {
				...state,
				order: action.payload,
				isLoading: false,
				isSaving: false,
				isSaved: true,
				isFailed: false,
				isLoaded: false,
			};
		case UPDATE_ORDER:
			return {
				...state,
				order: action.payload,
				isLoading: false,
				isSaving: false,
				isSaved: false,
				isUpdated: true,
				isLoaded: false,
				isFailed: false,
			};
		case LOAD_ORDER:
			return {
				...state,
				order: action.payload,
				isLoading: false,
				isSaving: false,
				isSaved: false,
				isUpdated: false,
				isLoaded: true,
				isFailed: false,
			};
		case ORDER_FAILED:
			return {
				...state,
				isLoading: false,
				isSaving: false,
				isSaved: false,
				isUpdated: false,
				isLoaded: false,
				isFailed: true,
			};
		default:
			return state;
	}
}
